module.exports = __webpack_public_path__ + "c90b4ccf3562ac2a9cefe05df694e445.svg";